import { Listbox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid'

export default function CustomListBoxDropdown({
    options,
    value,
    onChange,
    placeholder = 'Select option',
    shadow = ''
}) {
    const selectedOption = options.find((option) => option.value === value)

    return (
        <Listbox
            value={value}
            onChange={onChange}
        >
            <div className={`relative w-full ${shadow}`}>
                <Listbox.Button className='relative flex h-10 w-full items-center cursor-pointer rounded-lg border border-gray-300 bg-white pl-3 pr-10 text-left text-sm shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 shadow-md'>
                    <span className='flex items-center'>
                        <span className='block truncate'>
                            {selectedOption ? selectedOption.label : placeholder}
                        </span>
                    </span>

                    <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                        <ChevronUpDownIcon className='h-5 w-5 text-gray-400' />
                    </span>
                </Listbox.Button>

                <Transition
                    as="div"
                    leave='transition ease-in duration-100'
                    leaveFrom='opacity-100'
                    leaveTo='opacity-0'
                >
                    <Listbox.Options className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none'>
                        {options.map((option) => (
                            <Listbox.Option
                                key={option.value}
                                value={option.value}
                                className={({ active }) =>
                                    `relative cursor-pointer select-none py-2 pl-3 pr-9 ${active ? 'bg-orange-50' : ''}`
                                }
                            >
                                {({ selected }) => (
                                    <>
                                        <span className='flex items-center'>
                                            <span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                {option.label}
                                            </span>
                                        </span>

                                        {selected &&
                                            <span className='absolute inset-y-0 right-0 flex items-center pr-2 text-orange-600'>
                                                <CheckIcon className='h-5 w-5' />
                                            </span>
                                        }
                                    </>
                                )}
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </Transition>
            </div>
        </Listbox>
    )
}
